import { formatCustomDate } from './formatCustomDate';

// data_exb chega como 'yyyy-MM-dd HH:mm:ss'. 00:00 é o que a importação grava
// quando o banco não informa a hora: mostrar "00:00" daria a entender que o
// lançamento foi à meia-noite, então aí sai só a data.
export function formatDataExtrato(dataHora: string | null | undefined): string {
  if (!dataHora) return '';
  const data = formatCustomDate(
    dataHora.slice(0, 10),
    'yyyy-MM-dd',
    'dd/MM/yyyy',
  );
  const hora = dataHora.slice(11, 16);
  return hora && hora !== '00:00' ? `${data} ${hora}` : data;
}
